import { render, staticRenderFns } from "./IssuetrackingIndex.vue?vue&type=template&id=430a26cd&scoped=true&"
import script from "./IssuetrackingIndex.vue?vue&type=script&lang=js&"
export * from "./IssuetrackingIndex.vue?vue&type=script&lang=js&"
import style0 from "./IssuetrackingIndex.vue?vue&type=style&index=0&id=430a26cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430a26cd",
  null
  
)

export default component.exports